import * as Sentry from "@sentry/react";
import * as React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

import { config } from "@/lib/config";

export const initSentry = () => {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    environment: config.ENVIRONMENT,
    release: config.BUILD_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    tracesSampleRate: 0.1,
    tracePropagationTargets: ["localhost", config.API_URL],

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
  });
};
